const isDebugEnv =
  process.env.NODE_ENV === "development" ||
  process.env.NEXT_PUBLIC_VERCEL_ENV === "preview";

export function debugLog(...args: unknown[]) {
  if (isDebugEnv) {
    console.warn(...args);
  }
}
